import {
    ADD_FAVOURITE_SURVEY,
    FETCH_ALL_SURVEY,
    FETCH_ALL_SURVEY_SUCCESS,
    FILTER_SURVEY,
    GET_ALL_SURVEY,
    GET_UNSELECTED_ALL_SURVEY,
    HANDLE_SURVEY_REQUEST_CLOSE,
    HIDE_SURVEY_LOADER,
    SHOW_SURVEY_LOADER,
    ON_ADD_SURVEY,
    ON_ALL_SURVEY_SELECT,
    ON_SURVEY_CLOSE,
    ON_SURVEY_SELECT,
    ON_DELETE_SURVEY,
    ON_DELETE_SELECTED_SURVEY,
    ON_FILTER_SURVEY_OPTION_SELECT,
    ON_SAVE_SURVEY,
    ON_SAVE_SURVEY_SUCCESS,
    ON_TOGGLE_SURVEY_DRAWER,
    SHOW_SURVEY_MESSAGE,
    UPDATE_SEARCH_SURVEY,
    ON_SURVEY_QUESTIONS
} from 'constants/ActionTypes';

export const onSurveyQuestions = (data) => {
    return {
        type: ON_SURVEY_QUESTIONS,
        payload: data
    };
};
export const fetchSurveys = () => {
    return {
        type: FETCH_ALL_SURVEY
    };
};

export const fetchSurveysSuccess = (data) => {
    return {
        type: FETCH_ALL_SURVEY_SUCCESS,
        payload: data
    };
};
export const showSurveyMessage = (message) => {
    return {
        type: SHOW_SURVEY_MESSAGE,
        payload: message
    };
};
export const addFavouriteSurvey = (data) => {
    return {
        type: ADD_FAVOURITE_SURVEY,
        payload: data
    };
};
export const onSurveySelect = (data) => {
    return {
        type: ON_SURVEY_SELECT,
        payload: data
    };
};
export const onAddSurvey = () => {
    return {
        type: ON_ADD_SURVEY,
        payload: ''
    };
};
export const onSurveyClose = () => {
    return {
        type: ON_SURVEY_CLOSE,
        payload: ''
    };
};
export const onFilterSurveyOptionSelect = (option) => {
    return {
        type: ON_FILTER_SURVEY_OPTION_SELECT,
        payload: option
    };
};
export const onSaveSurvey = (data) => {
    return {
        type: ON_SAVE_SURVEY,
        payload: data
    };
};
export const onSaveSurveySuccess = (data) => {
    return {
        type: ON_SAVE_SURVEY_SUCCESS,
        payload: data
    };
};
export const onDeleteSurvey = (data) => {
    return {
        type: ON_DELETE_SURVEY,
        payload: data
    };
};
export const onDeleteSelectedSurvey = () => {
    return {
        type: ON_DELETE_SELECTED_SURVEY,
        payload: ''
    };
};
export const filterSurvey = (survey) => {
    return {
        type: FILTER_SURVEY,
        payload: survey
    };
};
export const getAllSurvey = () => {
    return {
        type: GET_ALL_SURVEY,
        payload: ''
    };
};
export const getUnselectedAllSurvey = () => {
    return {
        type: GET_UNSELECTED_ALL_SURVEY,
        payload: ''
    };
};
export const onAllSurveySelect = () => {
    return {
        type: ON_ALL_SURVEY_SELECT,
        payload: ''
    };
};
export const updateSearchSurvey = (survey) => {
    return {
        type: UPDATE_SEARCH_SURVEY,
        payload: survey
    };
};
export const onToggleSurveyDrawer = () => {
    return {
        type: ON_TOGGLE_SURVEY_DRAWER,
    };
};
export const handleSurveyRequestClose = () => {
    return {
        type: HANDLE_SURVEY_REQUEST_CLOSE,
    };
};
export const showSurveyLoader = () => {
    return {
        type: SHOW_SURVEY_LOADER,
    };
};
export const hideSurveyLoader = () => {
    return {
        type: HIDE_SURVEY_LOADER,
    };
};



// WEBPACK FOOTER //
// ./actions/Survey.js